import { render, staticRenderFns } from "./ValidatorSelect.vue?vue&type=template&id=5c819fb5&scoped=true&"
import script from "./ValidatorSelect.vue?vue&type=script&lang=js&"
export * from "./ValidatorSelect.vue?vue&type=script&lang=js&"
import style0 from "./ValidatorSelect.vue?vue&type=style&index=0&id=5c819fb5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c819fb5",
  null
  
)

export default component.exports